module.exports = __webpack_public_path__ + "static/img/draw-pic-card.936af281.png";